export const DEFAULT_SIDEBAR_WIDTH = '215px';
